import { Button, ButtonGroup } from '@mui/material';

export const OVERVIEW_PERIODS = [
    { id: 'mensal', label: 'Mensal' },
    { id: 'trimestral', label: 'Trimestral' },
    { id: 'semestral', label: 'Semestral' },
    { id: 'anual', label: 'Anual' },
];

export default function PeriodButtonGroup({ value, onChange }) {
    return (
        <ButtonGroup variant="outlined" size="small">
            {OVERVIEW_PERIODS.map(item => (
                <Button
                    key={item.id}
                    onClick={() => onChange(item.id)}
                    variant={value === item.id ? 'contained' : 'outlined'}
                    sx={{
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: value === item.id ? 600 : 400,
                    }}
                >
                    {item.label}
                </Button>
            ))}
        </ButtonGroup>
    );
}
